const ITEMS = [
  "EPOXIDHARZBÖDEN",
  "BODENBESCHICHTUNGEN",
  "HAUSMEISTERSERVICE",
  "GEBÄUDEREINIGUNG",
  "PFLASTERREINIGUNG",
  "PRIVAT & GEWERBE",
  "GRONAU (WESTF.) & KREIS BORKEN",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="service-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-surface py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg md:text-xl font-bold uppercase tracking-widest text-white/40">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
};
